(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/coupon-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/coupon-rows.js');
"use strict";


const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  CouponRow
} = svs.components.tipsen.couponScore;
const {
  useSelector
} = ReactRedux;
const {
  FetchDrawAnalysesByHook
} = svs.components.tipsen.hooks;
const {
  selectShowMatchAnalysesInCoupon
} = svs.components.tipsen.selectors;
const CouponRows = () => {
  const {
    drawEvents,
    drawNumber,
    productId,
    sportType
  } = useCurrentDraw() || {};
  const showMatchAnalysesInCoupon = useSelector(selectShowMatchAnalysesInCoupon);
  const shouldFetchMatchAnalyses = !showMatchAnalysesInCoupon.hideAll;
  return React.createElement(React.Fragment, null, React.createElement("ol", {
    className: "pg_coupon_rows"
  }, drawEvents.map(drawEvent => React.createElement(CouponRow, {
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    key: drawEvent.eventNumber,
    productId: productId,
    sportType: sportType
  }))), shouldFetchMatchAnalyses && React.createElement(FetchDrawAnalysesByHook, {
    drawNumber: drawNumber,
    productId: productId
  }));
};
setGlobal('svs.components.tipsen.couponScore.CouponRows', CouponRows);

 })(window);